module.exports = __webpack_public_path__ + "static/media/mtech-extc-scheme-2020.84a9ccbb.pdf";